module.exports = __webpack_public_path__ + "img/hadi.21386e58.jpg";